export const QUESTION_COUNTER_WIDTH = "40px";
